var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fj-warp d-f fd-c jc-sb bgc-fff fs-18 ff-roboto"},[_c('nuxt')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }